module.exports = __webpack_public_path__ + "89b7ee84a759d6fc972e066707698813.png";